import React, { useState } from 'react'
import classnames from 'classnames'
import { useRouter } from 'next/router'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import buildUrl from 'Pages/auto/home/utils'
import PriceInput from './price-input'
import { ContextStore } from './reducer'
import { IConditionsProps, ISortProps } from './interface'

interface IProps {
  conditions: IConditionsProps[]
  /* 展示更多条件下面的线 */
  hideline?: boolean
  foldprops: boolean
}

export default function Conditions({
  conditions,
  hideline,
  foldprops,
}: IProps) {
  const router = useRouter()
  // 是否展开条件
  const [fold, setFold] = useState(foldprops)
  /* 判断是否是条件的请求 */
  // const { dispatch } = React.useContext(ContextStore)
  const { state, dispatch } = React.useContext(ContextStore)

  const renderControlFold = () => {
    return (
      <div className={classnames({ line: !hideline })}>
        <span
          role="button"
          onClick={() => {
            setFold(!fold)
            sendTeaCommEvent('click_garage_series_selector_more')
          }}
        >
          {fold ? '收起 ' : '更多条件（结构/排量/配置）'}
          <span className="icon-arrow-ic-r arrow-down" />
        </span>
        <style jsx>
          {`
            div {
              margin: 0 20px;
              text-align: center;
            }
            div:hover {
              color: #406599;
            }
            .line {
              border-bottom: 1px solid #ededed;
            }
            span {
              line-height: 48px;
              cursor: pointer;
              transition: color 0.2s ease-in-out;
            }
            span:hover {
              color: #406599;
            }
            .arrow-down {
              color: #000;
              transform: rotate(${fold ? '-90deg' : '90deg'});
            }
          `}
        </style>
      </div>
    )
  }
  const getStat = (options: any) => {
    return Object.keys(options).reduce((acc: any, curr: string) => {
      acc[curr] = options[curr].map((item: any) => item.param).join(',')
      return acc
    }, {})
  }

  const allConditionKeys = React.useMemo(() => {
    return conditions.map(item => {
      return Array.from(
        new Set(item.data.map(item => item.key).filter(item => !!item))
      )
    })
  }, [conditions])

  const handleOptionClick = (item: ISortProps, line: number) => {
    // 第N行条件
    const currentLine = allConditionKeys[line]
    // dispatch({ type: 'conditions' })
    const newOptions = Object.assign({}, state)

    // 选择不限时，清空整行元素
    if (item.text.indexOf('不限') >= 0) {
      currentLine.forEach(key => {
        newOptions[key] = []
      })
      window.location.href = `/auto/library/${buildUrl(
        newOptions,
        allConditionKeys
      )}${window?.location?.search}`

      return
    }
    // 当为价格时，只能单选，其他情况可以多选
    if (item.key === 'price') {
      sendTeaCommEvent('click_garage_series_selector', {
        price: item.param,
      })
    }

    // 初始值为空
    if (!newOptions[item.key]) {
      newOptions[item.key] = []
    }

    newOptions[item.key] = [
      {
        text: item.text,
        param: item.param,
      },
    ]
    sendTeaCommEvent('click_garage_series_selector', getStat(newOptions))
    window.location.href = `/auto/library/${buildUrl(
      newOptions,
      allConditionKeys
    )}${window?.location?.search}`
  }

  function isOptionActive(option: ISortProps, line: number): boolean {
    if (!option) {
      return false
    }
    // 不限的高亮条件：同一行中没有被选中的元素
    if (option.text === '不限') {
      return !allConditionKeys[line].some(
        item => !!state[item] && state[item].length > 0
      )
    }
    if (!state[option.key] || !state[option.key].length) {
      return false
    }
    // ===部分条件筛选有问题
    if (state[option.key].some(item => item.param == option.param)) {
      return true
    }
    return false
  }

  return (
    <React.Fragment>
      <h2>条件筛选</h2>
      <section
        className={classnames({
          fold: !fold,
        })}
      >
        {conditions.map((data: IConditionsProps, line: number) => {
          return (
            <div className="conditions clearfix" key={data.title}>
              <span className="label fl">{data.title}：</span>
              {data.data.map((item: ISortProps) => {
                if (item.key === 'price' && item.text === '输入框') {
                  return (
                    <div className="condition-input">
                      <PriceInput
                        key={item.text}
                        onClick={handleOptionClick}
                        price={state.price}
                      />
                    </div>
                  )
                }
                return (
                  <span
                    key={item.text}
                    role="button"
                    className={classnames('condition', {
                      active: isOptionActive(item, line),
                    })}
                    onClick={event => {
                      event.stopPropagation()
                      handleOptionClick(item, line)
                    }}
                  >
                    {item.text}
                  </span>
                )
              })}
            </div>
          )
        })}
      </section>
      {renderControlFold()}
      <style jsx>
        {`
          h2 {
            line-height: 60px;
            margin: 0 20px;
            font-size: 24px;
            font-weight: 500;
            box-shadow: 0 1px 0 0 #ededed;
          }
          .fold {
            height: 268px;
            overflow: hidden;
          }
          .conditions {
            margin: 0 20px;
            padding: 0 0 12px;
            border-bottom: 1px solid #ededed;
          }
          .label {
            line-height: 28px;
            color: #666;
            margin-top: 10px;
          }
          .condition {
            display: inline-block;
            margin: 12px 2px 0;
            padding: 4px 8px;
            cursor: pointer;
            border-radius: 4px;
            transition: all 0.1s ease-in-out;
          }
          .condition:hover {
            background: rgba(255, 225, 0, 0.2);
          }
          .condition-input {
            display: inline-block;
            margin-top: 12px;
          }
          .active {
            background-color: #ffe100;
          }
          .active:hover {
            color: #1a1a1a;
            background-color: #ffe100;
          }
        `}
      </style>
    </React.Fragment>
  )
}
